module.exports = __webpack_public_path__ + "assets/img/help_pagination03-1.8359632d.svg";